import React, { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'

// MUI Imports
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Autocomplete,
  TextField,
  Chip
} from '@mui/material'

const DEFAULT_TITLE_OPTIONS = [
  'Import',
  'Purchasing',
  'Procurement',
  'Buyer',
  'Manager',
  'Director',
  'Chief',
  'Supply Chain',
  'Foreign Trade',
  'International Trade',
  'Founder',
  'Owner',
  'Vendor',
  'Sourcing',
  'Category',
  'Product Manager',
  'Business Development'
]

const MAX_TITLES = 10

const TitleFilterDialog = ({
  open,
  onConfirm,
  onCancel,
  loading = false
}) => {
  const { t } = useTranslation()
  const [selectedTitles, setSelectedTitles] = useState([])
  const inputRef = useRef(null)

  const isMaxReached = selectedTitles.length >= MAX_TITLES

  const handleEntered = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  const handleTitleChange = (event, newValue) => {
    if (newValue.length <= MAX_TITLES) {
      setSelectedTitles(newValue)
    }
  }

  const handleCancel = () => {
    setSelectedTitles([])
    onCancel()
  }

  const handleConfirm = () => {
    onConfirm(selectedTitles)
    setSelectedTitles([])
  }

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
      TransitionProps={{
        onEntered: handleEntered
      }}
    >
      <DialogTitle>
        {t('mailTemplate.titleFilterDialog.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {t('mailTemplate.titleFilterDialog.message')}
        </DialogContentText>
        <Autocomplete
          multiple
          freeSolo
          options={DEFAULT_TITLE_OPTIONS}
          value={selectedTitles}
          onChange={handleTitleChange}
          getOptionDisabled={() => isMaxReached}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                label={option}
                {...getTagProps({ index })}
                key={option}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              inputRef={inputRef}
              variant="outlined"
              label={t('mailTemplate.titleFilterDialog.selectLabel')}
              placeholder={isMaxReached ? '' : t('mailTemplate.titleFilterDialog.selectPlaceholder')}
              helperText={t('mailTemplate.titleFilterDialog.maxTitlesHelper', { count: selectedTitles.length, max: MAX_TITLES })}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary" disabled={loading}>
          {t('mailTemplate.titleFilterDialog.cancel')}
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          {loading
            ? t('mailTemplate.titleFilterDialog.confirming')
            : t('mailTemplate.titleFilterDialog.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TitleFilterDialog
